export default __webpack_public_path__ + "static/media/minus.5c04eecf.png";